export default "__VITE_ASSET__lwIVpVR1__"